module.exports = __webpack_public_path__ + "media/images/icon-hint-blue-fe51fbec89de6c5edd97e9d956c6828a.svg";